import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import axios from "axios";
import { BHAREE_BASE_URL_LOCAL } from "../../config/config.url";
import { formatTimer } from "../../utils/TimestampConverter";

const OtpModal = ({ show, onHide, contact, onVerified }) => {
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [timeLeft, setTimeLeft] = useState(120);
  const [canResend, setCanResend] = useState(false);
  const [otpMessage, setOtpMessage] = useState({}); // success: true | false

  // Countdown timer logic
  useEffect(() => {
    let timer;
    if (show && timeLeft > 0) {
      setCanResend(false);
      timer = setInterval(() => setTimeLeft((prev) => prev - 1), 1000);
    } else if (timeLeft === 0) {
      setCanResend(true);
    }
    return () => clearInterval(timer);
  }, [show, timeLeft]);

  const handleVerifyOtp = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        BHAREE_BASE_URL_LOCAL + "/auth/verifyOtp",
        {
          mobile_number: contact,
          otp: otp,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "x-guest-token": `${localStorage.guest_jwt_token}`,
          },
        }
      );
      if (res.data.success) {
        onVerified();
        onHide();
      } else {
        alert("Invalid OTP!");
      }
    } catch (err) {
      console.error("OTP verify error:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    try {
      setLoading(true);
      const res = await axios.post(
        BHAREE_BASE_URL_LOCAL + "/auth/getOtp",
        {
          mobile_number: contact,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "x-guest-token": `${localStorage.guest_jwt_token}`,
          },
        }
      );
      setTimeLeft(120);
      setCanResend(false);
      if (res && res.data) {
        setOtpMessage(res.data);
      }
    } catch (err) {
      console.error("Resend OTP error:", err);
      setOtpMessage(err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>Enter OTP</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {/* ✅ Inline success/error message */}
        {otpMessage.message && (
          <div
            className={`mb-1 ${otpMessage.success ? "text-success" : "text-danger"}`}
            style={{ fontSize: "0.9rem" }}
          >
            {otpMessage.message}
          </div>
        )}

        <Form.Group>
          <div className="d-flex justify-content-between align-items-center">
            <Form.Label className="mb-0">OTP</Form.Label>
            {!canResend ? (
              <small className="text-muted">Resend in {formatTimer(timeLeft)}</small>
            ) : (
              <small
                className="text-primary"
                style={{ cursor: "pointer" }}
                onClick={handleResendOtp}
              >
                Resend OTP
              </small>
            )}
          </div>
          <Form.Control
            type="text"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
            maxLength={6}
            placeholder="Enter 6-digit OTP"
          />
        </Form.Group>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="primary" onClick={handleVerifyOtp} disabled={loading || otp.length !== 6}>
          {loading ? "Verifying..." : "Verify OTP"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default OtpModal;
